import pythonApiClient from './pythonBaseApi';

export const gestionReservasApi = {
  getEstadosAsignacion: () =>
    pythonApiClient.get('/procesos/hoteleria/gestion-reservas/estados-asignacion'),

  getListado: (proyectoId, params = {}) =>
    pythonApiClient.get(
      `/procesos/hoteleria/gestion-reservas/proyecto/${proyectoId}/listado`,
      { params }
    ),

  getPropuestaFechas: (asignacionId, params = {}) =>
    pythonApiClient.get(
      `/procesos/hoteleria/gestion-reservas/asignacion/${asignacionId}/propuesta-fechas`,
      { params }
    ),

  actualizarFechasEstadia: (asignacionId, body) =>
    pythonApiClient.patch(
      `/procesos/hoteleria/gestion-reservas/asignacion/${asignacionId}/fechas-estadia`,
      body
    ),

  completarFechasEstadia: (body) =>
    pythonApiClient.post(
      '/procesos/hoteleria/gestion-reservas/completar-fechas-estadia',
      body
    ),
};

export default gestionReservasApi;
